import styled, { keyframes } from 'styled-components';
import { WHITE_COLOR } from '../../styles/variables';

const fadeText = keyframes` 
   from {
     opacity: 0;
     transform: translate3d(0, 100%, 0);
   }
   to {
     opacity: 1;
     transform: none;
   }
 `;

export const Container = styled.div`  
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 1);
  background: ${WHITE_COLOR};
  width: 70%;
  margin:auto;
  row-gap:1.5rem;
  animation: ${fadeText} 1.2s ease-in-out 0s forwards;
  .info {
    font-display: block;
    font-family: 'Glacial Indifference';
    text-align: center;
    font-size: 1.3rem;
   
  }
  .imgage {
    width: 60%;
  }
`;
